<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="row">
    <div class="col col-xs-12 col-sm-3">
      <div class="input">
        <app-label [control]="name" class="input__label" for="name">Name:</app-label>
        <mat-form-field>
          <input matInput id="name" maxlength="20" formControlName="name">
          <mat-error *ngIf="name.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-3">
      <div class="input">
        <app-label [control]="rasse" class="input__label" for="rasse">Rasse:</app-label>
        <mat-form-field>
          <input matInput id="rasse" maxlength="20" formControlName="rasse">
          <mat-error *ngIf="rasse.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-3">
      <div class="input">
        <app-label [control]="geburtsjahr" class="input__label" for="geburtsjahr">Geburtsjahr:</app-label>
        <mat-form-field>
          <input matInput id="geburtsjahr" maxlength="4" formControlName="geburtsjahr">
          <mat-error *ngIf="geburtsjahr.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          <mat-error *ngIf="geburtsjahr.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          <mat-error *ngIf="!geburtsjahr.hasError('pattern') && geburtsjahr.hasError('min')">{{ 'MINVALUE' | translate:{'value': geburtsjahr.errors.min.min} }}</mat-error>
          <mat-error *ngIf="!geburtsjahr.hasError('pattern') && geburtsjahr.hasError('max')">{{ 'MAXVALUE' | translate:{'value': geburtsjahr.errors.max.max} }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-3">
      <div class="input">
        <app-label [control]="geschlecht" class="input__label" for="geschlecht">Geschlecht:</app-label>
        <mat-form-field>
          <mat-select id="geschlecht" formControlName="geschlecht">
            <mat-option *ngFor="let hg of hundeGeschlecht | keyvalue" [value]="hg.key">{{ hg.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
